import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import VueLodash from 'vue-lodash'
Vue.use( VueLodash )

import VueTouch from '../node_modules/vue-touch/dist/vue-touch.min.js'
Vue.use( VueTouch )

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use( VueAxios, axios )

import vuexI18n from 'vuex-i18n'
Vue.use( vuexI18n.plugin, store )

// import translationsRu from './i18n/ru'
import translationsEn from './i18n/en'
Vue.i18n.add( 'en', translationsEn )
// Vue.i18n.add( 'ru', translationsRu )

// if ( localStorage.getItem('userLocale') ) {
//     Vue.i18n.set( localStorage.getItem('userLocale') )
// }
// else {
//     Vue.i18n.set('ru')
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
